import { ROUTES } from "@/app/routes";
import { COMPANY_SECTION } from "@/shared/components/layout/nav-company";
import { EVERYDAY_LATER, EVERYDAY_WEEK } from "@/shared/components/layout/nav-everyday";
import type { NavItem, NavSection } from "@/shared/components/layout/sidebar-nav.types";

export type { CountStyle, NavItem, NavSection } from "@/shared/components/layout/sidebar-nav.types";

export const EMPTY_NAV_INDICATORS = {
  indicators: {} as Record<string, { count?: number } | undefined>,
};
export const EMPTY_NAV_OVERRIDES: Record<string, Partial<NavItem>> = {};

export function buildNavIndicatorOverrides(navIndicators: {
  indicators: Record<string, { count?: number } | undefined>;
}): Record<string, Partial<NavItem>> {
  const overrides = Object.entries(INDICATOR_NAV_MAP).reduce<Record<string, Partial<NavItem>>>(
    (acc, [indicatorKey, routePath]) => {
      if ((navIndicators.indicators[indicatorKey]?.count ?? 0) > 0) {
        acc[routePath] = { newActivity: true };
      }
      return acc;
    },
    {},
  );
  return Object.keys(overrides).length > 0 ? overrides : EMPTY_NAV_OVERRIDES;
}

export const INDICATOR_NAV_MAP: Record<string, string> = {
  "feedback.forMe": ROUTES.workspace.feedback.path,
  "reviews.myReviews": ROUTES.workspace.reviews.path,
  "reviews.team": ROUTES.workspace.reviews.path,
  "approvals.forMe": ROUTES.workspace.approvals.path,
};

export const NAV_SECTIONS: NavSection[] = [EVERYDAY_WEEK, EVERYDAY_LATER, COMPANY_SECTION];

export function findNavItem(label: string): NavItem | undefined {
  return NAV_SECTIONS.flatMap((section) => section.items).find((item) => item.label === label);
}
